/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChunkResult } from '../../models/chunk-result';

export interface UpdateCustomersCache$Params {
}

export function updateCustomersCache(http: HttpClient, rootUrl: string, params?: UpdateCustomersCache$Params, context?: HttpContext): Observable<StrictHttpResponse<ChunkResult>> {
  const rb = new RequestBuilder(rootUrl, updateCustomersCache.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChunkResult>;
    })
  );
}

updateCustomersCache.PATH = '/customers-cache';
